import React, { Component } from "react";
import FormComponent from "../Form/FormComponent";
import { connect } from "react-redux";
import {
  systemSettingForm,
  systemSetting,
  systemSettingValidation,
  getData
} from "./SystemConfig";
import { fetchMethod } from "../../FetchMethod";
import { SemipolarLoading } from "react-loadingg";
import "./systemsetting.css";
class SystemSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      systemData: undefined,
      header: "System Settings",
      loading: false
    };
  }
  componentDidMount() {
    this.fetchData();
    this.props.onHandleSidebarText("/setting");
  }
  fetchData = () => {
    this.setState({ loading: true }, () => {
      fetchMethod(getData)
        .then(response => {
          return response.json();
        })
        .then(res => {
          this.setState({
            systemData: res.data.allSystemsettings.Systemsettings[0],
            loading: false
          });
        })
        .catch(e => console.log(e));
    });
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={50} color={"#004379"} />
        </div>
      );
    }
    return (
      <div className="systemsetting">
        <b>Campaign Global Settings</b>
        <div>
          <div>
            {this.state.systemData !== undefined ? (
              <FormComponent
                editableData={this.state.systemData}
                formConfig={systemSettingForm}
                formValidation={systemSettingValidation}
                query={systemSetting}
                message="System settings updated successfully"
                buttonName="Save"
                onButton="false"
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      })
  };
};
export default connect(null, mapDispatchToProps)(SystemSetting);
